<template>
  <div class="ppt-world">
    <div class="banner"></div>
    <div class="content">
      <div class="w-[1200px] mx-auto">
        <div class="owner">
          <div class="content-info">
            <Resource
              class="w-full host-shadow"
              :src="getFeUrl('/youyan-platform/png/ppt/owner.png')"
              :transform-resource="transformImage"
            ></Resource>
          </div>
        </div>
        <Resource
          class="w-full mt-[72px]"
          :src="getFeUrl('/youyan-platform/png/ppt/share.png')"
          :transform-resource="transformImage"
        ></Resource>
        <div class="mt-[72px] relative">
          <Resource
            class="w-full"
            :src="getFeUrl('/youyan-platform/png/ppt/step.png')"
            :transform-resource="transformImage"
          ></Resource>
          <Resource
            class="h-[88px] w-[104px] absolute right-[-115px] -top-[10px]"
            :src="getFeUrl('/youyan-platform/png/ppt/icon-step-gift.png')"
            :transform-resource="transformImage"
          ></Resource>
        </div>
        <div class="prize text-center">
          <Resource
            class="h-[308px] w-[333px] absolute left-[-90px] -top-[90px]"
            :src="getFeUrl('/youyan-platform/png/ppt/icon-prize-gift.png')"
            :transform-resource="transformImage"
          ></Resource>
          <Resource
            class="absolute top-[40%] -translate-y-1/2 right-[-180px] w-[205px] h-[188px]"
            :src="getFeUrl('/youyan-platform/png/ppt/prize-gift.png')"
            :transform-resource="transformImage"
          ></Resource>
          <Resource
            class="h-[108px] w-[499px]"
            :src="getFeUrl('/youyan-platform/png/ppt/gift-title.png')"
            :transform-resource="transformImage"
          ></Resource>
          <div v-for="(item, index) in prizeList" :key="index" class="relative mt-[90px]">
            <Resource
              class="w-[445px] h-[200px] absolute -top-[118px] -translate-x-1/2 left-1/2"
              :src="item.title"
              :transform-resource="transformImage"
              :style="{
                height: item.title_height ? item.title_height + 'px' : '',
                width: item.title_width ? item.title_width + 'px' : '',
                top: item.title_height ? '-' + item.title_height / 2 + 'px' : '',
              }"
            ></Resource>
            <Resource
              class="w-full"
              :src="item.content"
              :transform-resource="transformImage"
            ></Resource>
          </div>
        </div>
        <div class="judges text-center"></div>
        <div class="way text-center"></div>
      </div>
    </div>
    <div class="bottom">
      <div v-if="!isNamed" class="submit" @click="onSignUp">
        点击报名 <iconpark-icon name="arrowright" size="26"></iconpark-icon>
      </div>
      <div v-else class="preview" @click="open">
        查看我的参赛信息
        <iconpark-icon name="arrowright" size="26"></iconpark-icon>
      </div>
    </div>
    <OrderModal
      ref="modalRef"
      :width="408"
      :height="559"
      :icon="!isNamed"
      :title="isNamed ? '查看我的参赛信息' : '报名成功'"
      @close="onClose"
    >
      <template #content>
        <div class="order-content">
          <div class="z-10 relative">
            <div class="code">
              <div class="text-[15px] text-font-80">我的参赛码</div>
              <a-divider type="vertical"></a-divider>
              <div class="text-[16px] font-bold flex-1 text-center">
                {{ activeCode }}
              </div>
            </div>
            <div class="line"></div>
            <div class="mt-[23px] relative text-[18px] font-bold flex flex-col items-center">
              <div class="text-bg">
                <div class="z-10 relative text-[22px]">扫描下方二维码进群</div>
                <div class="line-bg"></div>
              </div>
              <div class="text-[18px] leading-[30px]">获取活动参与信息</div>
              <div class="mt-[17px]">
                <Resource
                  :src="codeUrl"
                  class="w-[250px] h-[250px]"
                  :transform-resource="transformImage"
                ></Resource>
              </div>
            </div>
          </div>
        </div>
      </template>
    </OrderModal>
  </div>
</template>

<script lang="ts" setup>
import { reqGetApply, reqPostApply, reqPostLandingPageVisit, type IChannel } from '@/api';
import { SESSION_PPT } from '@/constants/config';
import OrderModal from './components/modal.vue';

const props = defineProps<{
  qrcodeUrl?: string;
  channelList: IChannel[];
}>();
const userInfo = useUserInfo();
const route = useRoute();
const isNamed = ref(false);
const codeUrl = ref(props.qrcodeUrl);
let href = location.href;

const prizeList = [
  {
    title: transformImage(getFeUrl('/youyan-platform/png/ppt/prize-title-1.png')),
    content: transformImage(getFeUrl('/youyan-platform/png/ppt/prize-1.png')),
    height: 1171,
  },
  {
    title: transformImage(getFeUrl('/youyan-platform/png/ppt/prize-title-2.png')),
    content: transformImage(getFeUrl('/youyan-platform/png/ppt/prize-2.png')),
    height: 1196,
  },
  {
    title: transformImage(getFeUrl('/youyan-platform/png/ppt/prize-title-3.png')),
    content: transformImage(getFeUrl('/youyan-platform/png/ppt/prize-3.png')),
    height: 742,
  },
  {
    title: transformImage(getFeUrl('/youyan-platform/png/ppt/prize-title-special.png')),
    content: transformImage(getFeUrl('/youyan-platform/png/ppt/prize-special.png')),
    title_height: 78,
    title_width: 369,
    height: 1024,
  },
];
const modalRef = ref();
const activeCode = ref('');

const pptHref = localGetItem(SESSION_PPT);

const open = () => {
  modalRef.value.toggle?.();
};

const qSearch = () => {
  if (!pptHref) {
    return null;
  }

  const url = new URL(pptHref);
  const params: any = new URLSearchParams(url.search.slice(1));

  return params;
};

const qSearchParams = qSearch();

const source = computed(() => (qSearchParams && qSearchParams.get('pcode')) || route.query.pcode);
const immediateOpen = computed(
  () => (qSearchParams && qSearchParams.get('open')) || route.query.open,
);

const onSignUp = async () => {
  if (!href.includes('open=1')) {
    const querySearch = href.includes('?') ? '&open=1' : '?open=1';
    href += querySearch;
  }
  if (!pptHref) {
    localSetItem(SESSION_PPT, href);
  }

  if (!userInfo.value) {
    goLogin({
      redirect: encodeURIComponent(pptHref || href),
    });
    return;
  }

  const res = await reqPostApply({ channel_code: source.value || '' });
  const defaultYouyan = props.channelList?.find(v => v.code === '0')?.pc_link;
  codeUrl.value =
    props.channelList?.find(v => v.id === res.data?.channel_id)?.pc_link || defaultYouyan;
  localSetItem(SESSION_PPT, null);
  activeCode.value = res.data.code;
  open();
};

const onClose = () => {
  isNamed.value = true;
};

if (userInfo.value?.user_id) {
  await reqPostLandingPageVisit({
    channel_code: source.value,
  });
  const res = await reqGetApply();
  const data = res.data?.length ? res.data[0] : null;
  activeCode.value = data?.code || '';
  isNamed.value = !!data?.code;
  const defaultYouyan = props.channelList?.find(v => v.code === '0')?.pc_link;
  codeUrl.value = props.channelList?.find(v => v.id === data?.channel_id)?.pc_link || defaultYouyan;
  if (immediateOpen.value && !isNamed.value) {
    onSignUp();
  }
}

watch(userInfo, async () => {
  const res = await reqGetApply();
  const data = res.data?.length ? res.data[0] : null;
  activeCode.value = data?.code || '';
  isNamed.value = !!data?.code;
  const defaultYouyan = props.channelList?.find(v => v.code === '0')?.pc_link;
  codeUrl.value = props.channelList?.find(v => v.id === data?.channel_id)?.pc_link || defaultYouyan;
});

onBeforeUnmount(() => {
  if (!pptHref) {
    localSetItem(SESSION_PPT, href);
  }
});

const bannerBg = useCssBgUrl('/youyan-platform/png/ppt/banner.png?x-oss-process=image/format,webp');

const contentBg = useCssBgUrl(
  '/youyan-platform/png/ppt/content-bg.png?x-oss-process=image/format,webp',
);

const judgeBg = useCssBgUrl('/youyan-platform/png/ppt/judges.png?x-oss-process=image/format,webp');

const wayBg = useCssBgUrl('/youyan-platform/png/ppt/way-bg.png?x-oss-process=image/format,webp');
</script>

<style lang="scss" scoped>
.ppt-world {
  @apply relative;
  .host-shadow {
    background: linear-gradient(180deg, rgba(249, 244, 255, 0.95) 0%, #ffffff 100%);
    box-shadow: 0px 5px 32px 0px rgba(13, 3, 212, 0.08);
    border-radius: 39px;
    backdrop-filter: blur(6px);
  }
  .bottom {
    @apply fixed bottom-[0px] h-[212px] w-full text-white flex-y-center justify-center;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
    .submit {
      @apply w-[274px] h-[67px] rounded-[34px] flex-y-center justify-center text-[24px] font-bold cursor-pointer;
      background: linear-gradient(180deg, #5e56ff 0%, #838eff 100%);
      &:hover {
        background: linear-gradient(180deg, #8a85ff 0%, #b2b9ff 100%);
      }
    }
    .preview {
      @apply w-[574px] h-[67px] rounded-[34px] flex-y-center justify-center text-[24px] font-bold cursor-pointer;
      background: linear-gradient(180deg, #bf50ff 0%, #fe75fb 100%);
      &:hover {
        background: linear-gradient(180deg, #c662ff 0%, #f3ceff 100%);
      }
    }
  }
  .banner {
    background: v-bind('bannerBg') no-repeat;
    background-position: bottom;
    background-size: cover;
    height: 797px;
    width: 100%;
  }
  .content {
    @apply w-full mx-auto pb-[195px];
    background: v-bind('contentBg') no-repeat;
    background-position: center center;
    background-size: 100% 100%;
    .owner {
      @apply relative h-[640px];
      .content-info {
        @apply w-full absolute -top-[81px];
      }
    }
    .prize {
      @apply px-[72px] mt-[110px] rounded-[35px] relative pb-[69px];
      background: linear-gradient(183deg, #9195ff 0%, #f3f8fd 100%);
    }
    .judges {
      @apply h-[710px] mt-[63px];
      background: v-bind('judgeBg') no-repeat;
      background-position: center center;
      background-size: contain;
    }
    .way {
      @apply h-[850px] mt-[46px];
      background: v-bind('wayBg') no-repeat;
      background-position: center center;
      background-size: contain;
    }
  }
}
.order-content {
  @apply p-[20px_35px] rounded-[20px] relative;
  z-index: 10;
  box-shadow: 0px 2px 12px 0px rgba(222, 222, 255, 0.4);
  &::before,
  &::after {
    z-index: 1;
    content: ' ';
    position: absolute;
    top: 0;
    width: 51%;
    height: 100%;
  }

  &::before {
    left: 0;
    background-image: radial-gradient(circle 10px at left 105px, transparent 10px, #ffffff 50%);
    border-radius: 12px 0 0 12px;
  }
  &::after {
    right: 0;
    background-image: radial-gradient(circle 10px at right 105px, transparent 10px, #ffffff 50%);
    border-radius: 0px 12px 12px 0;
  }

  .code {
    @apply bg-back-2  rounded-[11px] flex-y-center p-[15px_23px];
  }
  .line {
    @apply mt-[26px] relative;
    width: 100%;
    height: 1px;
    background-image: linear-gradient(to right, #dddcff 0%, #dddcff 50%, transparent 50%);
    background-size: 10px 1px;
    background-repeat: repeat-x;
  }
  .text-bg {
    @apply relative;
    .line-bg {
      z-index: 1;
      position: absolute;
      bottom: 0;
      left: 0;
      height: 10px;
      width: 100%;
      background: linear-gradient(180deg, #deddff 0%, #eff0fa 100%);
    }
  }
}
</style>
